import { useState } from 'react'
import { DocumentType } from '@kistill/shared/types'

export const useListViewToolbar = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [stickersPopUp, setStickersPopUp] = useState<boolean>(false)
  const [changeLocationPopUp, setChangeLocationPopUp] = useState<boolean>(false)
  const [columnMenuAnchorEl, setColumnMenuAnchorEl] =
    useState<null | HTMLElement>(null)

  const openMenu = Boolean(anchorEl)
  const columnMenuOpen = Boolean(columnMenuAnchorEl)

  const handleClose = () => {
    setAnchorEl(null)
    if (stickersPopUp) {
      setStickersPopUp(false)
    }
    if (changeLocationPopUp) {
      setChangeLocationPopUp(false)
    }
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleDocumentAndClose = (
    enumType: DocumentType,
    onDocument: (enumType: DocumentType) => void,
  ) => {
    onDocument(enumType)
    handleClose()
  }

  const constOpenStickerPopUp = () => {
    setStickersPopUp(true)
    handleClose()
  }

  const constOpenChangeLocationPopUp = () => {
    setChangeLocationPopUp(true)
    handleClose()
  }

  const handleOpenColumnMenu = (event: React.MouseEvent<HTMLElement>) => {
    setColumnMenuAnchorEl(event.currentTarget)
  }

  const handleCloseColumnMenu = () => {
    setColumnMenuAnchorEl(null)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function getGuids(selected: readonly string[], totalGuids: any) {
    const guidsToOpen = selected.length > 0 ? 'selectedGuids' : 'totalGuids'

    const guids =
      guidsToOpen === 'totalGuids'
        ? totalGuids
        : guidsToOpen === 'selectedGuids'
          ? selected
          : null
    return guids
  }

  return {
    anchorEl,
    openMenu,
    stickersPopUp,
    setStickersPopUp,
    changeLocationPopUp,
    setChangeLocationPopUp,
    columnMenuAnchorEl,
    columnMenuOpen,
    handleClose,
    handleClick,
    handleDocumentAndClose,
    constOpenStickerPopUp,
    constOpenChangeLocationPopUp,
    handleOpenColumnMenu,
    handleCloseColumnMenu,
    getGuids,
  }
}
